import { render, staticRenderFns } from "./campaigns-table.vue?vue&type=template&id=118e9ff0&"
import script from "./campaigns-table.vue?vue&type=script&lang=js&"
export * from "./campaigns-table.vue?vue&type=script&lang=js&"
import style0 from "./campaigns-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports